import debug from 'debug';
import { getFilesByProject } from '@services/files';
import { GETTING_FILES, GOT_FILES, FilesActionType } from '@store/types';

export const getProjectFiles = (path: string) => {
  const log = debug('getProjectFiles');
  return (dispatch: (action: FilesActionType) => void): any => {
    dispatch({ type: GETTING_FILES });
    getFilesByProject(path)
      .then((files) => {
        dispatch({ type: GOT_FILES, payload: files });
      })
      .catch((error) => {
        log({ error });
      });
  };
};
